import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { SelectedCategory } from '../types/Education.type';

export const useEducationParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const categoriesParam = searchParams.get('categories');

  const selectedCategories = useMemo<SelectedCategory[]>(() => {
    if (!categoriesParam) return [];

    try {
      const parsed = JSON.parse(categoriesParam);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }, [categoriesParam]);

  const setCategories = (categories: SelectedCategory[]) => {
    const nextParams = new URLSearchParams(searchParams);

    if (categories.length > 0) {
      nextParams.set('categories', JSON.stringify(categories));
    } else {
      nextParams.delete('categories');
    }

    setSearchParams(nextParams);
  };

  const clearCategories = () => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('categories');
    setSearchParams(nextParams);
  };

  return {
    selectedCategories,
    categoriesIds: selectedCategories.map((c) => String(c.id)),
    hasSelection: selectedCategories.length > 0,
    selectedCount: selectedCategories.length,
    setCategories,
    clearCategories,
  };
};
